
export default async function createAPISearch(debug = false) {
  let containers = document.querySelectorAll('.search-form');
  if (! containers) return;

  const { default: APISearch } = await import('../classes/APISearch');

  containers.forEach(container => {
    new APISearch(container, debug);
  });
}
